import { AddFundStructureType, EditFundStructureType } from "./types";

export const addFundStructureSlr = (state: any): AddFundStructureType =>
	state.fundDetails.fund.fundStructure.addFundStructure;
export const editFundStructureSlr = (state: any): EditFundStructureType =>
	state.fundDetails.fund.fundStructure.editFundStructure;
